// The ⊗ on a multi-select chip (ui/multi-select, ui/multi-select-form-field,
// ui/custom/multi-select). Each sits inside the trigger button.

import { touchHitArea } from '@/components/ui/touch-target';

/**
 * A 44px hit area on touch screens, lifted (z-index) over the trigger's own
 * phone hit area: the Button's ::after covers the whole trigger and would
 * otherwise take the tap and open the list. Chip removes sit over the
 * "+N more" one, so where the hit areas of wrapped rows overlap, a tap
 * removes one chip rather than several.
 */
export const CHIP_REMOVE_TOUCH_CLASS = `${touchHitArea('', { coarse: true })} max-md:z-[2] touch:z-[2]`;
export const EXTRA_REMOVE_TOUCH_CLASS = `${touchHitArea('', { coarse: true })} max-md:z-[1] touch:z-[1]`;

/**
 * After a chip is removed with Enter or Space, keep focus in the field: the
 * focused ⊗ goes with its chip, so focus the ⊗ that took its place (or the
 * last one), else the trigger. Removes carry `data-chip-remove`.
 */
export const keepFocusAfterChipRemove = (remove: HTMLElement) => {
	const trigger = remove.closest('button');
	if (!trigger) return;
	const index = [...trigger.querySelectorAll('[data-chip-remove]')].indexOf(remove);
	let frames = 0;
	const refocus = () => {
		// Some fields only re-render a frame or two later.
		if (remove.isConnected && ++frames < 10) return void requestAnimationFrame(refocus);
		const active = document.activeElement;
		if (active && active !== document.body && !trigger.contains(active)) return;
		const removes = [...trigger.querySelectorAll<HTMLElement>('[data-chip-remove]')];
		(removes[Math.min(index, removes.length - 1)] ?? trigger).focus();
	};
	requestAnimationFrame(refocus);
};
